// extracted by mini-css-extract-plugin
export default {"feedbackBox":"AdminUserFeedback_feedbackBox__QKY8M","description":"AdminUserFeedback_description__FScan","break":"AdminUserFeedback_break__5CL9P"};